import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

/**
 * @description USE WITH CAUTION - narrows template typing of very pesky forms.
 *
 * @summary Something like the Play Template Builder uses 4 different types of criteria, all
 * held in a single array. This works fine, but the types have to be narrowed on a
 * case by case basis. This is easy enough to do in Typescript, but quite hard to do
 * in the template. In situations like this, this pipe is just fine. HOWEVER,
 * make sure to type the form in the input component class properly.
 *
 * In my opinion (Michael), this is much much better so Typescript classes can be narrowed, rather
 * than dozens upon dozens of `as X` or `as Y` in them. Only the template gets the `as` treatment.
 */
@Pipe({
    name: 'r1NarrowWideFormTypes',
})
export class NarrowWideFormTypesPipe implements PipeTransform {
    transform(value: AbstractControl): UntypedFormGroup {
        return value as UntypedFormGroup;
    }
}
